import Core from '../../../Core';
import {
  tools
} from '../../../GenericTools.lib';

export function mapGreenhousePayload({
  candidate,
  atsJobId,
  atsSourceId,
  atsReferrerId,
}) {
  const {
    firstName: first_name,
    lastName: last_name,
    currentEmployer: company,
    currentTitle: title,
    phone,
    email,
    gitHubURL,
    linkedInURL,
  } = candidate;
  const result = {
    candidate: {
      first_name,
      last_name,
      company,
      title,
      phone_numbers: [],
      email_addresses: [],
      website_addresses: [],
    },
    errors: []
  };

  if (phone) {
    if (tools.validatePhone(phone)) {
      result.candidate.phone_numbers.push({
        value: phone, type: "home"
      });
    }
    else {
      result.errors.push(`Phone number must have at least 10 digits`);
      result.errors.push(`"${phone}"`);
    }
  }

  if (email) {
    if (tools.validateEmail(email)) {
      result.candidate.email_addresses.push({
        value: email, type: "personal"
      });
    }
    else {
      result.errors.push(`Email is badly formatted.`);
      result.errors.push(`"${email}"`);
    }
  }

  if (gitHubURL) {
    if (tools.validateURL(gitHubURL)) {
      result.candidate.website_addresses.push({
        value: gitHubURL, type: "personal"
      });
    }
    else {
      result.errors.push(`Website is badly formatted.`);
      result.errors.push(`"${gitHubURL}"`);
    }
  }

  if (linkedInURL) {
    if (tools.validateURL(linkedInURL)) {
      result.candidate.website_addresses.push({
        value: linkedInURL, type: "personal"
      });
    }
    else {
      result.errors.push(`Website is badly formatted.`);
      result.errors.push(`"${linkedInURL}"`);
    }
  }

  if (Core.isLocalHost()) {
    result.candidate.first_name = '_' + result.candidate.first_name;
    result.candidate.last_name = '_' + result.candidate.last_name;
  }

  result.candidate.application = {
    source_id: +(atsSourceId),
    referrer_id: +(atsReferrerId),
    job_id: +(atsJobId),
  }

  return result;
}

